import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

function PaymentSuccess() {
  const location = useLocation();
  const { plan, orderId, payer, amount } = location.state || {};
  console.log("location", location.state);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  if (!plan) {
    return (
      <div className="content-inner pb-0 container-fluid" id="page_layout">
        <div className="row row--grid">
          {/* breadcrumb */}
          <div className="col-12">
            <ul className="breadcrumb">
              <li className="breadcrumb__item">
                <Link to="/">Home</Link>
              </li>
              <li className="breadcrumb__item">
                <a>Payment</a>
              </li>
            </ul>
          </div>
          <div className="container text-center mt-5">
            <div className="card bg-dark text-white p-5">
              <h3 className="text-white">Invalid Access</h3>
              <p>Please complete a payment first.</p>
              <Link to="/" className="btn btn-primary mt-3">
                Back to Plans
              </Link>
            </div>
          </div>{" "}
        </div>
      </div>
    );
  }

  return (
    <div className="content-inner pb-0 container-fluid" id="page_layout">
      <div className="row row--grid">
        {/* breadcrumb */}
        <div className="col-12">
          <ul className="breadcrumb">
            <li className="breadcrumb__item">
              <Link to="/">Home</Link>
            </li>
            <li className="breadcrumb__item">
              <a>Payment</a>
            </li>
          </ul>
        </div>
        <div className="container mt-5">
          <div className="row justify-content-center">
            <div className="col-md-8">
              <div className="card bg-dark text-white shadow-lg">
                <div className="card-header bg-success text-center">
                  <i className="fas fa-check-circle fa-3x mb-3"></i>
                  <h2 className="mb-0">Payment Successful!</h2>
                </div>
                <div className="card-body p-5">
                  <div className="text-center  mb-4">
                    <h4 className="text-white">Thank you</h4>
                    <p className="text-muted">
                      Your payment has been processed successfully.
                    </p>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <h5 className="text-white">Order Details</h5>
                      <ul className="list-unstyled">
                        <li>
                          <strong>Plan:</strong> {plan.name}
                        </li>
                        <li>
                          <strong>Amount:</strong> ${amount}
                        </li>
                        <li>
                          <strong>Order ID:</strong> {orderId}
                        </li>
                      </ul>
                    </div>
                    <div className="col-md-6">
                      <h5 className="text-white">Payer Information</h5>
                      <ul className="list-unstyled">
                        <li>
                          <strong>Name:</strong> {payer?.name?.given_name}{" "}
                          {payer?.name?.surname}
                        </li>
                        <li>
                          <strong>Email:</strong> {payer?.email_address}
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div className="mt-4 p-3 bg-secondary rounded">
                    <h6>What's Next?</h6>
                    <p className="mb-0">
                      You will receive a confirmation email shortly. Your{" "}
                      {plan.name} Plan is now active!
                    </p>
                  </div>

                  <div className="text-center mt-4">
                    <Link to="/" className="btn btn-primary me-3">
                      <i className="fas fa-home me-2"></i>
                      Back to Home
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PaymentSuccess;
